module.exports = __webpack_public_path__ + "static/media/step-3-bw.c0781140.png";